import i18n from 'i18next';
import LanguageDetector from "i18next-browser-languagedetector";

let lng = undefined
if (process.env.REACT_APP_LANGUAGE) {
  if (process.env.REACT_APP_LANGUAGE !== "auto") {
    lng = process.env.REACT_APP_LANGUAGE
  }
}

i18n
  .use(LanguageDetector)
  .init({
    lng,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      "en": { translation: require('./en.json') },
      "nl": { translation: require('./nl.json') }
    }
  });

export default i18n;
